// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2NM5g","colMin":"styles_colMin__h8TCM","colCheckbox":"styles_colCheckbox__3mGe_"};